import { createContext, useState } from 'react';
import api from 'services/api';
import moment from 'moment';

const filter = {
  like: '',
  id: '',
  entidade: [],
  dtvenc: {
    i: null,
    f: moment().format('YYYY-MM-DD'),
  },
  documento: '',
  parcela: '',
  valor: '',
  valor_baixado: '',
  valor_pendente: '',
  valor_outros: '',
  forma_pagto: [],
  filial: [],
  dtemissao: {
    i: null,
    f: null,
  },
  dtentrada: {
    i: null,
    f: null,
  },
  observacao: '',
};

export const PagamentosPendentesContext = createContext();

export const PagamentosPendentesProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [pagamentosPendentes, setPagamentosPendentes] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getPagamentosPendentes = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: pagamentosPendentes?.filter,
        page: pagamentosPendentes?.page,
        size: pagamentosPendentes?.size,
        order: pagamentosPendentes?.order,
        ...payload,
      });
      setPagamentosPendentes((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <PagamentosPendentesContext.Provider
      value={{
        getLoading,
        getPagamentosPendentes,
        pagamentosPendentes,
      }}
    >
      {children}
    </PagamentosPendentesContext.Provider>
  );
};
